import React from 'react';
import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import { createUseStyles } from 'react-jss';
import { Button } from '../core/Button';
import { SplitHeroBtnProps } from '~helpers/types';
import { getUrlWithUtsource3 } from '~app/pages/SurveyThanks/utils';

const useStyles = createUseStyles({
  splitHeroButton: {
    '& a': {
      width: '100%',
    },
  },
});

const SplitHeroButton = ({
  href,
  text,
  metricsData,
  size = 'lg',
  variant = 'default',
  isTemplatePage = false,
  ...metricsProps
}: SplitHeroBtnProps): React.ReactElement => {
  const classes = useStyles();
  const {
    utSource,
    utSource2,
    utSource3,
    amplitudeEvent,
    templateType,
    surveyId,
    collectorId,
    respondentId,
    interactionType,
  } = metricsProps;

  const buttonHref = isTemplatePage
    ? getUrlWithUtsource3(
        `${href}%3Fut_source%3Dsurvey-thanks%26ut_source2%3D${utSource2}%26ut_source3%3DUTSOURCE3_VALUE`,
        utSource3
      )
    : createURL(href, {
        ut_source: utSource,
        ut_source2: utSource2,
        ut_source3: utSource3,
        ut_ctatext: metricsData.ut_ctatext,
      });

  const dataMetrics = generateMetricsAttribute({
    data: {
      amplitudeEvent,
      itemSelected: metricsData.itemSelected,
      templateType,
      interactionType,
      surveyId,
      collectorId,
      respondentId,
      log: { message: `${utSource}-${utSource2}-${utSource3}` },
    },
  });

  return (
    <Button
      size={size}
      className={size === 'md' ? classes.splitHeroButton : ''}
      variant={variant === 'ghost' ? 'secondary' : undefined}
      onDark={variant !== 'default' && size === 'lg'}
      href={buttonHref}
      data-sm-metrics={dataMetrics}
    >
      {text}
    </Button>
  );
};

export default SplitHeroButton;
